import { withRouter } from 'next/router';
import { useTranslations } from 'ilenia';

import {
  SingleResourceArticle,
  RelatedResources,
  BelowTheFoldContent,
} from 'components/SingleResourceView';
import { Search } from 'components/ResourceSearch';
import { BaseLayout } from 'layouts/BaseLayout';
import { ResourceProvider } from 'main-contexts';
import { fetchSingleResource } from 'queries/resources';
import { PillarNavigation } from 'components/ResourcePillarNavigation';

const GuideReport = ({
  router: {
    query: { pillar },
  },
  guideReport,
  relatedGuidesReports,
}) => {
  const [translations] = useTranslations();

  return (
    <BaseLayout>
      <ResourceProvider value="guides-reports">
        <PillarNavigation
          breadcrumbs={translations['guides-reports/page/title']}
          searchBar={
            <Search
              contentfulResource="guideReport"
              placeholder={translations['guides-reports/search']}
            />
          }
        />

        <SingleResourceArticle pillar={pillar} resource={guideReport} />

        <RelatedResources relatedResources={relatedGuidesReports} />

        <BelowTheFoldContent resource={guideReport} />
      </ResourceProvider>
    </BaseLayout>
  );
};

export const getServerSideProps = async (ctx) => {
  try {
    const { resource, relatedArticles, locale } = await fetchSingleResource({
      ctx,
      content_type: 'guideReport',
    });

    if (
      !resource ||
      (resource?.locale !== 'US' && resource?.locale !== locale.countryCode)
    ) {
      return { notFound: true };
    }

    return {
      props: {
        guideReport: resource,
        locale,
        relatedGuidesReports: relatedArticles,
      },
    };
  } catch (e) {
    if (e.message === 'NEXT_NOT_FOUND') {
      return { notFound: true };
    } else {
      throw e;
    }
  }
};

export default withRouter(GuideReport);
